// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2V50r","title":"AfterFrontImage_title__2-S-1"};